import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "sources",
    defaultRoutePath: "/advertisings/source",
    menuItemScope: "operations",
    menuItemName: "source",

    routes: [
        {
            path: "/advertisings/source",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
